import React from "react";
import PropTypes from "prop-types";
import "../../styles/GapSelect.scss";
import ErrorMessage from "../error-message/ErrorMessage";

const GapSelect = (props) => {
    const { name, handleChange, handleBlur, id, label, isRequired, itemList, fieldRegister, errorMessage, value } = props;

    return (
        <React.Fragment>
            {label && <label className={isRequired ? "required" : ""}>{label}</label>}
            <div className="custom-select">
                <select data-testid={id} id={id} className={errorMessage ? "input input--error" : "input"} name={name} onChange={handleChange} onBlur={handleBlur} value={value} {...fieldRegister}>
                    <option data-testid="options" value="" disabled>-Select-</option>
                    {
                        itemList.length > 0 && itemList.map((item, index) => {
                            return <option key={index} value={item.code}>{item.description}</option>
                        })
                    }
                </select>
                <i className="fas fa-caret-down custom-select__down-icon"></i>
            </div>
            {errorMessage && <ErrorMessage error={errorMessage} />}
        </React.Fragment>
    );
}

GapSelect.propTypes = {
    name: PropTypes.string,
    id: PropTypes.string,
    label: PropTypes.string,
    errorMessage: PropTypes.string,
    handleChange: PropTypes.func,
    handleBlur: PropTypes.func,
    isRequired: PropTypes.bool,
    itemList: PropTypes.array,
    fieldRegister: PropTypes.object,
    value: PropTypes.string,
}

export default GapSelect;